import React from "react";
import { MusicPracticeRoomStep2ContainerStyled } from "./styled";
import { withRouter } from "navigations/withRouter";
import { ROUTE_PATH } from "utils/constants/routePath";
import queryString from "query-string";
import { withTranslation } from "react-i18next";
import { userService } from "apiServices";
import moment from "moment";
import { toast } from "react-toastify";
import { RENDER_API_ERROR_MESSAGE } from "utils/functions/roomBooking";
import {
  BtnRoomBookingSentWidget,
  HeaderBackMusicPracticeWidget,
} from "widgets";
import { Displays, Forms, Headers, Navigations } from "components";

class MusicPracticeRoomStep2Container extends React.Component {
  state = {
    isLoading: true,
  };

  componentDidMount() {
    const query = this.buildQueryString({}, true);
    this.fetchData(query);
  }

  fetchData = async (query) => {
    const { router, i18n } = this.props;
    let resArr = await Promise.all([
      userService.GET_ROOM_LIST(`?pagination=false&type=2`),
      userService.GET_ROOM_AVAILABILITY_LIST(query),
    ]);
    if (resArr) {
      let findRoom = resArr[0].data.docs.find(
        (e) => String(e._id) === router.params.id,
      );
      this.setState({
        roomData: findRoom,
        dataHoliday: resArr[1].data,
        initialValues: {
          ...queryString.parse(router.location.search),
          // หาห้องไม่เจอ (เช่น id ใน url ผิด) ต้องเป็น "" ให้ฟอร์มขึ้น error ไม่ใช่ส่ง room_ref_id ว่างไป API
          room_ref_id: findRoom
            ? {
                label:
                  i18n.language === "en" ? findRoom.name_en : findRoom.name_th,
                value: findRoom._id,
              }
            : "",
        },
        isLoading: false,
      });
    }
  };

  // QUERY FLOW
  // =========================================
  // =========================================
  buildQueryString = (additionalParams = {}, isInitial = false) => {
    const { router } = this.props;
    const urlParams = queryString.parse(router.location.search);
    const defaultQuery = {
      room_id: router.params.id,
      start_date: moment().startOf("week").format("YYYY-MM-DD"),
      end_date: moment().endOf("week").format("YYYY-MM-DD"),
    };
    const finalParams = {
      ...defaultQuery,
      ...urlParams,
      ...additionalParams,
    };
    // end_date ต้องตามสัปดาห์ของ start_date เสมอ ไม่งั้นกด next แล้ว start > end API จะไม่คืน booking
    finalParams.end_date = moment(finalParams.start_date)
      .endOf("week")
      .format("YYYY-MM-DD");
    const cleanParams = Object.entries(finalParams)
      .filter(
        ([key, value]) => value !== null && value !== undefined && value !== "",
      )
      .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {});
    // ต้อง encode ค่า เพราะ url พา special_request (หมายเหตุพิมพ์อิสระ) ไปด้วย
    // ถ้ามี & # หรือขึ้นบรรทัดใหม่ แล้วต่อสตริงดิบ ๆ url จะเพี้ยนและหมายเหตุขาด
    const query = `?${Object.entries(cleanParams)
      .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
      .join("&")}`;
    if (isInitial) {
      router.navigate(
        `${ROUTE_PATH.MUSIC_PRACTICE_ROOM}/${router.params.id}/booking/2${query}`,
        { replace: true },
      );
    } else {
      router.navigate(
        `${ROUTE_PATH.MUSIC_PRACTICE_ROOM}/${router.params.id}/booking/2${query}`,
      );
    }

    return query;
  };
  handleChangeMonth = (e) => {
    this.setState({
      dateValue: e,
    });
    this.handleJoinQuery({
      start_date: moment(`${e.value}-01`, "YYYY-MM-DD")
        .startOf("week")
        .format("YYYY-MM-DD"),
    });
  };
  onClickPrevWeek = () => {
    const { router } = this.props;
    const urlParams = queryString.parse(router.location.search);
    this.handleJoinQuery({
      start_date: moment(urlParams.start_date)
        .startOf("week")
        .subtract(7, "days")
        .format("YYYY-MM-DD"),
    });
  };
  onClickNextWeek = () => {
    const { router } = this.props;
    const urlParams = queryString.parse(router.location.search);
    this.handleJoinQuery({
      start_date: moment(urlParams.start_date)
        .add(7, "days")
        .format("YYYY-MM-DD"),
    });
  };
  handleJoinQuery = (additionalQuery) => {
    const query = this.buildQueryString(additionalQuery);
    this.setState({
      isLoading: true,
    });
    this.fetchData(query);
  };

  handleBack = () => {
    const { router } = this.props;
    const { id } = this.props.router.params;
    // ย้อนกลับไปขั้นข้อมูลติดต่อ (ก่อนหน้า step 2)
    router.navigate(
      `${ROUTE_PATH.MUSIC_PRACTICE_ROOM}/${id}/booking/contact${router.location.search}`,
    );
  };

  handleSubmit = async (values) => {
    const { initialValues } = this.state;
    let params = {
      ...initialValues,
      ...values,
      room_ref_id: values.room_ref_id.value,
      event_start_time: values.event_start_time.value,
      event_end_time: values.event_end_time.value,
      type: "2",
    };
    let res = await userService.POST_ROOM_BOOKING_DRAFT(params);
    if (res && res.status === 200) {
      this.setState({
        isBgLoading: false,
      });

      toast.success(this.props.t("Save draft successfully", { ns: "common" }));
      const queryStringTemp = new URLSearchParams({
        ...initialValues,
        ...values,
        room_booking_id: res.data._id,
        room_ref_id: values.room_ref_id.value,
        event_start_time: values.event_start_time.value,
        event_end_time: values.event_end_time.value,
        is_preview: true,
      }).toString();
      this.props.router.navigate(
        `${ROUTE_PATH.MUSIC_PRACTICE_ROOM}/${values.room_ref_id.value}/booking/1?${queryStringTemp}`,
      );
    } else {
      this.setState({
        isBgLoading: false,
      });
      // เวลาชนกับคิวอื่น บอกให้ชัดว่ามีคนจองแล้ว ไม่ใช่ระบบจองไม่ได้
      const errorMessage = String(res?.data?.error?.message || "");
      const isSlotTaken = errorMessage.includes("Room is not available");
      // ใบร่างเก่าที่เลือกเวลาเกิน 17.30 ไว้ก่อนจำกัดเวลา (API draft ไม่รับแล้ว)
      const isOverTimeLimit = errorMessage.includes("until 17.30");
      // เวลาที่จองสั้นกว่าขั้นต่ำ 30 นาที (API draft ไม่รับ)
      const isUnderMinDuration = errorMessage.includes("minimum booking");
      // วันจองย้อนหลัง (เช่น ใบร่างเก่าที่เลยวันไปแล้ว) ข้อความอยู่ใน common.json เหมือน error อื่นของ API
      const isPastDate = errorMessage.includes(
        "Booking date must not be in the past.",
      );
      toast.error(
        isSlotTaken
          ? this.props.t(
              "This time slot has already been booked. Please select another time.",
              { ns: "room" },
            )
          : isOverTimeLimit
            ? this.props.t("Music practice room can be booked until 17:30 only.", {
                ns: "room",
              })
            : isUnderMinDuration
            ? this.props.t("Music practice room minimum booking is 30 minutes.", {
                ns: "room",
              })
            : isPastDate
              ? this.props.t("Booking date must not be in the past.", {
                  ns: "common",
                  nsSeparator: false,
                  keySeparator: false,
                })
              : // error อื่นจาก API (เช่น ปิดวันจันทร์ / ใบร่างหมดอายุ) แปลจาก common.json ไม่มีคำแปลใช้ข้อความกลาง
                RENDER_API_ERROR_MESSAGE(
                  res,
                  this.props.t("Save draft failed", { ns: "common" }),
                ),
      );
    }
  };

  render() {
    const { router, t, i18n } = this.props;
    const DATE_BREADCRUMB = [
      {
        name: t("Home", { ns: "common" }),
        path: ROUTE_PATH.HOME,
      },
      {
        name: t("Music Practice Room", { ns: "common" }),
        path: `${ROUTE_PATH.MUSIC_PRACTICE_ROOM}`,
      },
    ];
    const isPreview =
      queryString.parse(router.location.search)?.is_preview === "true";
    const {
      isLoading,
      initialValues,
      dateValue,
      dataHoliday,
      roomData,
    } = this.state;
    const urlParams = queryString.parse(router.location.search);
    // navigate ใน componentDidMount โดน react-router ข้าม URL ครั้งแรกจึงยังไม่มี start_date
    const startDate =
      urlParams?.start_date || moment().startOf("week").format("YYYY-MM-DD");
    const endDate = moment(startDate).endOf("week").format("YYYY-MM-DD");
    return (
      <MusicPracticeRoomStep2ContainerStyled>
        <div className="breadcrumb_layout">
          <Navigations.Breadcrumb data={DATE_BREADCRUMB} />
        </div>
        <div className="music_practice_container">
          {!isPreview ? (
            <div className="header_layout">
              <Headers.NewPageHeader
                title={"MUSIC PRACTICE ROOM"}
                sub_title={"ห้องซ้อมดนตรี"}
              />
            </div>
          ) : (
            <div className="header_backhome_layout">
              <HeaderBackMusicPracticeWidget
                room_booking_id={
                  queryString.parse(router.location.search)?.room_id
                }
              />
            </div>
          )}
          {isPreview && (
            <div className="title_preview">
              {t("Review Information", { ns: "common" })}
            </div>
          )}
          {/* ห้องที่ลูกค้าเลือกมาจากหน้ารายการห้อง (หน้าตาเดียวกับการ์ดห้องในหน้านั้น) */}
          {roomData && (
            <div className="room_info_layout">
              <div className="room_name">
                {i18n.language === "en" ? roomData.name_en : roomData.name_th}
              </div>
              {roomData.pricing?.hourly_rate !== undefined && (
                <div className="room_price">
                  {roomData.pricing.hourly_rate} THB/Hour.
                </div>
              )}
            </div>
          )}
          <div className="detail_layout">
            <Displays.TitleReserve
              theme_text_black
              title_reserve="รายละเอียดในการจอง"
            />
          </div>
          {isLoading ? (
            <Displays.Loading />
          ) : (
            <div className="form_layout">
              <Forms.MusicPracticeRoomSelectDateForm
                isDisabledForm={isPreview}
                initialValues={initialValues}
                type="room"
                dateValue={dateValue}
                startDate={startDate}
                endDate={endDate}
                timeSlotData={
                  dataHoliday.docs.filter((e) => e.reason_closed !== "1") || []
                }
                holidayData={
                  dataHoliday.docs.filter((e) => e.reason_closed === "1") || []
                }
                onBack={this.handleBack}
                onClickPrevWeek={this.onClickPrevWeek}
                onClickNextWeek={this.onClickNextWeek}
                onChangeMonth={this.handleChangeMonth}
                onSubmit={this.handleSubmit}
              />
            </div>
          )}
          {isPreview && (
            <div className="btn_confirm_wrap">
              <BtnRoomBookingSentWidget
                room_booking_id={
                  queryString.parse(router.location.search)?.room_booking_id
                }
              />
            </div>
          )}
        </div>
      </MusicPracticeRoomStep2ContainerStyled>
    );
  }
}

export default withTranslation(["common", "room"])(
  withRouter(MusicPracticeRoomStep2Container),
);
